import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { SalesStatisticsFilter } from '../../features/statistics/statisticsSlice';
import { ExternalEmailFeedbackEmailReplyDto } from '../../features/feedbacks/FeedbacksSlice';
import { SettlementReportRequest } from '../../features/statistics/settlementReportSlice';

export function fetchSalesStatistics(
  salesStatisticsFilter: SalesStatisticsFilter,
) {
  return axios
    .post('/statistics/statistics/getsalesstatistics', salesStatisticsFilter, {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      responseType: 'blob',
    })
    .then(res => res.data);
}

export function fetchSettlementReport(
  settlementReportRequest: SettlementReportRequest,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/statistics/statistics/GetSettlementReport',
      settlementReportRequest,
      config,
    )
    .then(res => res.data);
}
